import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import MemberList from './pages/member-list';
import MemberRegistration from './pages/member-registration';
import LoginPage from './pages/login';
import MemberImport from './pages/member-import';
import MemberDetails from './pages/member-details';
import MemberDashboard from './pages/member-dashboard';
import UserManagement from './pages/user-management';
import UserCreation from './pages/user-creation';
import UserProfileEdit from './pages/user-profile-edit';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/member-list" element={<MemberList />} />
        <Route path="/member-registration" element={<MemberRegistration />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/member-import" element={<MemberImport />} />
        <Route path="/member-details" element={<MemberDetails />} />
        <Route path="/member-dashboard" element={<MemberDashboard />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/user-creation" element={<UserCreation />} />
        <Route path="/user-profile-edit" element={<UserProfileEdit />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;